import {  SET_FILTER_STATUS, SET_SEARCH_TXT, SET_TIME_FRAME } from "./types";

export const setSearchTxt = (text) => {
    return {
        type: SET_SEARCH_TXT,
        payload: text
        
    }
}
export const setFilterStatus = (status) => {
    return {
        type: SET_FILTER_STATUS,
        payload: status
        
    }
}
export const setTimeFrame = (timeframe) => {
    return {
        type: SET_TIME_FRAME,
        payload: timeframe
        
    }
}
